module.exports = __webpack_public_path__ + "static/media/1_2.47eb37d7.png";